export enum CarrierType { 
    NETS = 'Nets',
    CRATES = 'Crates'
}